export default __webpack_public_path__ + "static/media/tehdas_koneistus_360.397869ca.jpg";